<template>
  <ul
    v-if="total_pages>1"
    class="pagiwrap"
  >
    <li :class="'pagi-links '+(current_page>1?'':'off')">
      <button
        aria-label="Go to first page"
        type="button"
        @click="pageSelect(1)"
      >
        First
      </button>
    </li>
    <li
      :class="'pagi-links '+(current_page>1?'':'off')"
      class="pagination-prev"
    >
      <button
        aria-label="Go to previous page"
        type="button"
        @click="(current_page>1?pageSelect(current_page-1):'')"
      >
        <span class="md">Prev</span>
        <span class="sm">Previous Page</span>
      </button>
    </li>
    <li
      v-for="n in (current_page+10)"
      v-if="n>(current_page-5) && n<Math.max(current_page+5,10)"
      class="pagi-links"
    >
      <button
        v-if="n<=total_pages"
        :aria-label="`Go to page number ${n}`"
        :class="(current_page==n?'on':'')"
        type="button"
        @click="pageSelect(n)"
      >
        {{ n }}
      </button>
    </li>
    <li
      :class="'pagi-links '+(current_page<total_pages?'':'off')"
      class="pagination-next"
    >
      <button
        aria-label="Go to next page"
        type="button"
        @click="(current_page<total_pages?pageSelect(current_page+1):'')"
      >
        <span class="md">Next</span>
        <span class="sm">Next Page</span>
      </button>
    </li>
    <li :class="'pagi-links '+(current_page<total_pages?'':'off')">
      <button
        aria-label="Go to last page"
        type="button"
        @click="pageSelect(total_pages)"
      >
        Last
      </button>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    params: {
      type: Object,
    },
    data: {
      type: Object,
    },
    limit: {
      type: Number,
    },
  },
  computed: {
    current_page() {
      return this._findProp('current_page', 1);
    },
    total_pages() {
      if (typeof this.limit !== 'undefined') {
        return Math.min(this.limit, this._findProp('last_page', 1));
      }

      return this._findProp('last_page', 1);
    },
  },
  methods: {
    pageSelect(x) {
      try {
        this.$el.parentElement.scrollIntoView(true);
      } catch (e) {
        // Dont cause the entire script to fail if we cannot scroll the
        // parent element into view. I'm not sure exactly when this
        // would happen but pagination is used in many places.
        console.error(e);
      }

      if (this.$listeners && this.$listeners['pagination-change-page']) {
        // Old syntax, found in IndividualResources.vue, et al.
        this.$emit('pagination-change-page', x);

        return;
      }

      // New syntax, found in FoodGroups.vue, et al.
      this.$emit('go-to-page', x);
    },
    _findProp(name, fallback) {
      const propsToSearch = ['params', 'data'];

      try {
        for (const prop of propsToSearch) {
          if (typeof this[prop] !== 'undefined') {
            if (typeof this[prop].meta !== 'undefined') {
              return this[prop].meta[name];
            }

            return this[prop][name];
          }
        }

        return fallback;
      } catch (e) {
        console.error(e);

        return fallback;
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.pagiwrap {
    list-style-type: none;
    margin: 20px 0;
    text-align: center;
    width: 100%;
    padding: 0;
}

.pagiwrap li {
    display: inline-block;
    padding: 0 4px;
}

.pagiwrap li button {
    border: 1px solid #ccc;
    padding: 4px;
    min-width: 32px;
    text-align: center;
    background: #efefef;
    margin: 0;
    color: #000;
}

.pagiwrap .sm {
    display: none;
}

.pagiwrap li button:hover, .pagiwrap li button.on {
    border: 1px solid #5f9f3b;
    color: #5f9f3b;
}

.pagiwrap li.off button:hover, .pagiwrap li.off button {
    color: #aaa;
    border-color: #ddd;
}

@media screen and (max-width: 769px) {
    .pagiwrap li:not(.pagination-next, .pagination-prev) {
        display: none;
    }

    .pagiwrap .md {
        display: none;
    }

    .pagiwrap .sm {
        display: initial;
    }
}

</style>
